export const BASE_URL = "https://monitai.hoststronger.site/api";
// export const BASE_URL = "http://127.0.0.1:8000/api"

//add comment to test front pushes 